import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	sortButtonLabelAsc: {
		id: 'jql-builder-basic-order-by-select.common.sort-direction-icon.sort-button-label-asc',
		defaultMessage: '{field} ordered by ascending. Reverse order',
		description:
			'Indicates to screen reader users that the current sort direction is ascending and the action will be to reverse the sort direction on click',
	},
	sortButtonLabelDesc: {
		id: 'jql-builder-basic-order-by-select.common.sort-direction-icon.sort-button-label-desc',
		defaultMessage: '{field} ordered by descending. Reverse order',
		description:
			'Indicates to screen reader users that the current sort direction is descending and the action will be to reverse the sort direction on click',
	},
	sortButtonWithDefaultAscDirectionLabel: {
		id: 'jql-builder-basic-order-by-select.common.sort-direction-icon.sort-button-with-default-asc-direction-label',
		defaultMessage: '{field} does not have a sort direction. Set the direction to ascending',
		description:
			'Indicates to screen reader users that the current selected field has no sort direction and the user can set it to ascending sort direction',
	},
});

export default messages;
